<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs" />
    <heading :helpInfo="sidebarCard">{{ periodTitle }}</heading>
    <medkitlogTable />
  </div>
</template>

<script>
import medkitlogTable from "@/views/medkitlog/medkitlogTable.vue";
import i18n from "../../i18n";
import { monthLabel } from "../../utils/monthLabel";
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
export default {
  name: "medkitlog",
  components: { medkitlogTable },
  computed: {
    year() {
      return this.$route.params.year;
    },
    month() {
      return this.$route.params.month;
    },
    periodTitle() {
      return `${monthLabel(this.month, this.$i18n.locale)} ${this.year}`;
    },
    breadcrumbs() {
      return [
        {
          text: i18n.t("sidebar.medkitlogs"),
          disabled: false,
          href: "/app/medkitlogs",
        },
        {
          text: this.year,
          disabled: false,
          href: `/app/medkitlogs/year/${this.year}`,
        },
        {
          text: monthLabel(this.month, this.$i18n.locale),
          disabled: true,
        },
      ];
    },
    sidebarCard() {
      if (this.$i18n.locale == "en") return sidebarTextEN.default.medkitlog;
      return sidebarTextDE.default.medkitlog;
    },
  },
};
</script>
